import React from 'react';
import FAQSection from '../components/sections/FAQSection';

const FAQPage = () => {
  return (
    <div className="pt-20">
      <FAQSection />
    </div>
  );
};

export default FAQPage;